import React from 'react';
import styled from 'styled-components';

export const SpacedSpan = styled.span`
  padding-right: 15px;
`;

const SquigglyError = styled.div`
  display: inline-block;
  position: relative;
  background: url("data:image/svg+xml,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%206%203'%20enable-background%3D'new%200%200%206%203'%20height%3D'3'%20width%3D'6'%3E%3Cg%20fill%3D'%23c24038'%3E%3Cpolygon%20points%3D'5.5%2C0%202.5%2C3%201.1%2C3%204.1%2C0'%2F%3E%3Cpolygon%20points%3D'4%2C0%206%2C2%206%2C0.6%205.4%2C0'%2F%3E%3Cpolygon%20points%3D'0%2C2%201%2C3%202.4%2C3%200%2C0.6'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E")
    repeat-x bottom left;
`;

export const RedSquigglyLine = ({ children }) => {
  return <SquigglyError data-testid={'redSquigglyDisplay'}>{children}</SquigglyError>;
};

export const RedSquigglySpace = () => {
  return (
    <SquigglyError data-testid={'redSquigglyDiv'}>
      <SpacedSpan />
    </SquigglyError>
  );
};
